import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DtoBuySellOrderVm} from '../../../Model/items/DtoBuySellOrderVm';
import {LoginVm} from '../../../Model/LoginVM';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {UserType} from '../../../Shared/Enums/UserType';
import {AuthService} from '../../../Shared/Services/auth.service';
import {DialogService} from '../../../Shared/Services/dialog.service';
import {CustomToastrService} from '../../../Shared/Services/custom-toastr.service';
import {SharedService} from '../../../Shared/Services/shared.service';
import {BuySellOrderService} from '../../../Services/buy-sell-order.service';
import {itemsVM} from "../../../Model/items/itemsVM";

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrl: './invoice.component.scss'
})
export class InvoiceComponent {
  @Input() BuySellOrderData!: DtoBuySellOrderVm;
  categorizedItems: { category: string, items: itemsVM[] }[] = [];
  currentUser: LoginVm = {};
  @Output() showInvoice = new EventEmitter<boolean>();
  dateNow = new Date();
  @Input() showClose: boolean = true;

  constructor(private api: BuySellOrderService, private auth: AuthService, private router: Router, private dialogService: DialogService,
              private spinner: NgxSpinnerService, private toastrService: CustomToastrService, private shared: SharedService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      this.spinner.show();
      this.GetCurrentUser();
      this.BuySellOrderData.items.forEach(item => {
        let cat = this.categorizedItems.find(c => c.category == item.mainCategoryName);
        if (cat) {
          cat.items.push(item);
        } else {
          this.categorizedItems.push({category: item.mainCategoryName, items: [item]});
        }
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
    this.spinner.hide();
  }

  Cancel() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoBack',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.showInvoice.emit(false);
      }
    });
  }

  exportPDF() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      this.spinner.show();
      this.BuySellOrderData.currentUserName = this.currentUser.name!;
      this.BuySellOrderData.currentUserPhone = this.currentUser.phoneNumber!;
      this.api.DownLoadPdf(this.BuySellOrderData)
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.shared.downloadBlobFile(data, 'invoice');
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }
}
